import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import config from 'cityads-v3/config';

import {
  toggleMenu,
} from 'cityads-v3/actions/menu';

import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import MenuContent from './MenuContent';

import classes from './Menu.scss';

@withRouter
@connect(state => ({
  opened: state.menu.opened,
  docked: state.menu.docked,
}))
export default class MenuMobile extends Component {

  static propTypes = {
    opened: PropTypes.bool,
    toggleMenu: PropTypes.func,
  }

  onToggle = open => () => this.props.dispatch(toggleMenu(open));

  render() {
    const { opened } = this.props;

    return (
      <SwipeableDrawer
        open={opened}
        onOpen={this.onToggle(true)}
        onClose={this.onToggle(false)}
        swipeAreaWidth={ config.MOBILE_SWIPE_AREA_WIDTH }
        variant="temporary"
        classes={{
          paper: classes.menuContainer
        }}
      >
        <MenuContent/>
      </SwipeableDrawer>
    );
  }

}
